import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ArticleType } from 'src/app/modules/entities/article-type';
import { Article } from 'src/app/modules/entities/article';
import { ArticleTypeService } from 'src/app/modules/services/article-type.service';
import { ArticleService } from 'src/app/modules/services/article.service';
import { errorDescription, url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-create-article',
  templateUrl: './create-article.component.html',
  styleUrls: ['./create-article.component.css']
})
export class CreateArticleComponent implements OnInit {

  constructor (private router: Router, private fb: FormBuilder, 
    private articleTypeService: ArticleTypeService, private articleService: ArticleService,
    private messageService: MessageService) {
      this.articleForm = this.fb.group({
        urlId: ['', [Validators.required, Validators.maxLength(100)]],
        author: ['MuyComplacientes', [Validators.maxLength(45)]],
        content: [''],
        summary: ['', [Validators.maxLength(300)]],
        title: ['', [Validators.maxLength(300)]],
        image: ['', [Validators.maxLength(1000)]],
        metaTitle: ['', [Validators.maxLength(300)]],
        metaDescription: ['', [Validators.maxLength(1000)]],
        visible: [true],
        articleType: ['', [Validators.required]]
      }) 
    }
  
  articleTypeList: ArticleType[] = [];
  articleForm: FormGroup;
  loading: boolean = false;
    
  ngOnInit(): void {
    this.articleTypeService.getArticleTypes().subscribe({
      next: response => {
        if (response.status === 'success'){
          this.articleTypeList = response.data;
        } else {
          this.messageService.add({severity: 'error', detail: 'Error consultando los tipos de artículo'});
        }
      },
      error: error => {
        this.messageService.add({severity: 'error', detail: errorDescription[error.error.error]});
        this.router.navigate([url['login']]);
      }
    })
  }

  createArticle() {
    this.loading = true;
    let article: Article = {
      urlId: this.articleForm.get('urlId')?.value,
      author: this.articleForm.get('author')?.value,
      content: this.articleForm.get('content')?.value,
      summary: this.articleForm.get('summary')?.value,
      title: this.articleForm.get('title')?.value,
      image: this.articleForm.get('image')?.value,
      publicationDate: new Date(),
      metaTitle: this.articleForm.get('metaTitle')?.value,
      metaDescription: this.articleForm.get('metaDescription')?.value,
      visible: this.articleForm.get('visible')?.value,
      articleType: this.articleForm.get('articleType')?.value
    };
    this.articleService.saveArticle(article).subscribe({
      next: response => {
        if (response.status === 'success') {
          this.messageService.add({severity: response.status, summary: 'Artículo creado con éxito'});
        } else {
          this.messageService.add({severity: response.status, summary: 'Ocurrió un error creando el artículo'});
        }
        this.loading = false;
      },
      error: error => {
        this.messageService.add({severity: 'error', detail: errorDescription[error.error.error], summary: 'Ocurrió un error creando el artículo'});
      }
    });
  }

}
